<template>
  <transition-group tag="div" name="slide-fade" mode="out-in" class="slides">
    <div :class="['slide', image.class]" :key="image.title">
      <!--[if IE]> <div class="triangulos"></div> <![endif]-->

      <div class="container">
        <div class="content">
          <div class="cont-inner">
            <div class="row">
              <div class="col-md-4" :class="offset">
                <h1 class="title">{{ image.title }}</h1>
                <h2 class="subtitle">{{ image.subtitle }}</h2>
                <p class="desc d-none d-md-block">{{ image.desc }}</p>
                <button
                  class="btn btn-outline-light rounded-0 font-weight-bold"
                >
                  + info
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'Slides',
  props: ['image'],
  computed: {
    offset() {
      if (this.image.special) {
        return 'offset-md-7 offset-lg-8'
      } else {
        if (this.image.right) {
          return 'offset-md-8'
        }
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.slide {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  position: absolute;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: stretch;
}
.slide1 {
  background-image: url('~@/assets/images/slide01.jpg');
}
.slide2 {
  background-image: url('~@/assets/images/slide02.jpg');
}
.slide3 {
  background-image: url('~@/assets/images/slide03.jpg');
}
.slide4 {
  background-image: url('~@/assets/images/slide04.jpg');
}
.slide5 {
  background-image: url('~@/assets/images/slide05.jpg');
}

.content {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
}

.cont-inner {
  color: #fff;
  z-index: 60;
  padding: 15px 15px;
  animation: slideCont 2s ease-in-out;
  .title {
    position: relative;
    display: inline;
    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 50px;
      height: 50px;
      top: -25px;
      left: 50%;
      transform: translateX(-50%);
      background-image: url('~@/assets/images/ardilla.svg');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .subtitle {
    font-family: 'Antonio', sans-serif;
  }
  .desc {
    font-family: 'Antonio', sans-serif;
    line-height: 1.2rem;
  }
}

@media (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .cont-inner {
    padding: 100px 15px 15px;
  }
  .slide4 {
    background-position: 100% 50%;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .cont-inner {
    padding: 100px 15px 15px;
    .title {
      font-size: 4rem;
      line-height: 4rem;
      &::before {
        width: 70px;
        height: 70px;
        top: -35px;
      }
    }
    .subtitle {
      font-size: 2.5rem;
      line-height: 2.5rem;
      font-weight: 300;
    }

    .title {
      text-align: unset;
    }
  }
  .slide4 {
    background-position: center;
  }
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}

.slide-fade-enter-active {
  animation: slideFadeEnter ease-in-out 1s;
}

.slide-fade-leave-active {
  animation: slideFadeLeave ease-in-out 1.5s;
  animation-iteration-count: 1;
  position: absolute;
}
.slide-fade-move {
  transition: all 1s;
}

@keyframes slideFadeEnter {
  from {
    // opacity: 0;
    transform: translateX(100%);
  }
  to {
    // opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideFadeLeave {
  from {
    // opacity: 1;
    transform: translateX(0);
  }
  to {
    // opacity: 0;
    transform: translateX(-100%);
  }
}

@keyframes slideCont {
  from {
    opacity: 0;
    transform: translateX(200px);
  }
  to {
    transform: translateX(0);
  }
}
</style>
